export enum ButtonSize {
  small = "sm",
  medium = "md",
  large = "lg",
}

export enum ButtonType {
  primary = "PRIMARY",
  secondary = "SECONDARY",
  danger = "DANGER",
  glass = "GLASS",
}

export type ButtonTypes = {
  label: string;
  loading?: boolean;
  disabled?: boolean;
  widthFull?: boolean;
  onClick: () => void;
  size?: ButtonSize;
  icon?: string;
  type?: ButtonType;
  blink?: boolean;
};
